import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { audit } from '@/data';
import { PageHeader } from '@/components/layout/PageHeader';
import { SectionCard } from '@/components/ui/Card';
import { Btn } from '@/components/ui/Button';
import { Badge } from '@/components/ui/Badge';

export default function Audit() {
  const { t } = useTranslation();
  const rows0 = audit;
  const [actFilter, setActFilter] = useState('all');
  const [resFilter, setResFilter] = useState('all');
  const [q, setQ] = useState('');

  const resTone: Record<string, 'success' | 'warning' | 'danger'> = { ok: 'success', fail: 'warning', denied: 'danger' };
  const resLabel: Record<string, string> = { ok: t('resOk'), fail: t('resFail'), denied: t('resDenied') };
  const actIcon: Record<string, string> = {
    actLogin: 'bi-box-arrow-in-right', actLogout: 'bi-box-arrow-right', actView: 'bi-eye',
    actCreate: 'bi-plus-circle', actEdit: 'bi-pencil', actDelete: 'bi-trash3',
    actExport: 'bi-download', actPerm: 'bi-shield-lock',
  };
  const acts = ['actLogin', 'actView', 'actCreate', 'actEdit', 'actDelete', 'actExport', 'actPerm', 'actLogout'];

  const rows = rows0.filter((r) =>
    (actFilter === 'all' || r.act === actFilter) &&
    (resFilter === 'all' || r.res === resFilter) &&
    (q === '' || r.user.toLowerCase().includes(q.toLowerCase()) || r.target.toLowerCase().includes(q.toLowerCase())));

  const counts = {
    total: rows0.length,
    today: rows0.filter((r) => r.time.startsWith('2026-06-15')).length,
    denied: rows0.filter((r) => r.res === 'denied').length,
    fail: rows0.filter((r) => r.res === 'fail').length,
  };

  return (
    <div className="mp-page" data-screen-label="감사로그">
      <PageHeader
        crumbs={[t('home'), t('mSystem'), t('mAudit')]}
        title={t('auditTitle')}
        titleExtra={<div className="mp-pagehead__meta"><span className="mp-pagehead__updated">{t('auditSub')}</span></div>}
        actions={<Btn icon="bi-file-earmark-excel">{t('excel')}</Btn>}
      />

      <div className="mp-summary">
        <div className="mp-summary__item">
          <span className="mp-summary__label">{t('auditTotal')}</span>
          <span className="mp-summary__num">{counts.total}<small>{t('items')}</small></span>
        </div>
        <div className="mp-summary__item">
          <span className="mp-summary__label">{t('auditToday')}</span>
          <span className="mp-summary__num">{counts.today}<small>{t('items')}</small></span>
        </div>
        <div className="mp-summary__item">
          <span className="mp-summary__label">{t('auditDenied')}</span>
          <span className="mp-summary__num mp-summary__num--danger">{counts.denied}<small>{t('items')}</small></span>
        </div>
        <div className="mp-summary__item">
          <span className="mp-summary__label">{t('auditFail')}</span>
          <span className="mp-summary__num mp-summary__num--warn">{counts.fail}<small>{t('items')}</small></span>
        </div>
      </div>

      <div className="mp-filterbar">
        <label className="mp-filter">
          <span>{t('filterAction')}</span>
          <select value={actFilter} onChange={(e) => setActFilter(e.target.value)}>
            <option value="all">{t('all')}</option>
            {acts.map((a) => <option key={a} value={a}>{t(a)}</option>)}
          </select>
        </label>
        <label className="mp-filter">
          <span>{t('filterResult')}</span>
          <select value={resFilter} onChange={(e) => setResFilter(e.target.value)}>
            <option value="all">{t('all')}</option>
            <option value="ok">{t('resOk')}</option>
            <option value="fail">{t('resFail')}</option>
            <option value="denied">{t('resDenied')}</option>
          </select>
        </label>
        <label className="mp-filter">
          <span>{t('filterUser')}</span>
          <input type="text" value={q} onChange={(e) => setQ(e.target.value)} placeholder={t('filterUser')} />
        </label>
        <Btn small icon="bi-arrow-counterclockwise" onClick={() => { setActFilter('all'); setResFilter('all'); setQ(''); }}>{t('reset')}</Btn>
        <span className="mp-filterbar__count">{t('total')} <strong>{rows.length}</strong> {t('items')}</span>
      </div>

      <SectionCard flush>
        <table className="mp-table mp-audittable">
          <thead>
            <tr>
              <th>{t('colTime')}</th>
              <th>{t('colUser')}</th>
              <th>{t('colAction')}</th>
              <th>{t('colTarget')}</th>
              <th>{t('colModule')}</th>
              <th>{t('colIp')}</th>
              <th>{t('colResult')}</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={i}>
                <td className="mp-mono">{r.time}</td>
                <td className="mp-table__strong">{r.user}</td>
                <td>
                  <span className="mp-actcell">
                    <i className={'bi ' + (actIcon[r.act] || 'bi-dot')}></i>{t(r.act)}
                  </span>
                </td>
                <td>{r.target}</td>
                <td>{t(r.mod)}</td>
                <td className="mp-mono">{r.ip}</td>
                <td><Badge tone={resTone[r.res]}>{resLabel[r.res]}</Badge></td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="mp-pagination">
          <button type="button"><i className="bi bi-chevron-left"></i></button>
          <button type="button" className="is-current">1</button>
          <button type="button">2</button>
          <button type="button">3</button>
          <button type="button"><i className="bi bi-chevron-right"></i></button>
        </div>
      </SectionCard>
    </div>
  );
}
